
import { Auth0Client } from '@auth0/auth0-spa-js';

export const getTokenWrapper = async (
  auth0Client: Auth0Client | null
): Promise<string | null> => {
  let tokenWithBearer = null;
  const token = await auth0Client?.getTokenSilently();

  if (token) {
    tokenWithBearer = `Bearer ${token}`;
  }
  return tokenWithBearer;
}
